export default "__VITE_ASSET__B6t08sCt__"